var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-advance-select", {
    ref: "salesCompany",
    attrs: {
      "select-type": _vm.TYPE_NAMES.basic_data_Company,
      "method-params": _vm.methodParams,
      "hand-trigger-value": _vm.$store.getters.currentOfficeUuid,
      "clear-not-match": _vm.clearNotMatch,
      filterable: "",
      disabled: _vm.disabled,
      "callback-params": _vm.callbackParams,
      multiple: _vm.multiple,
      "default-value": _vm.defaultValue,
      "default-multiple-value": _vm.defaultMultipleValue,
      "tag-value": _vm.tagValue,
      "options-width": "optionsWidth",
      headers: _vm.headers,
      fields: _vm.fields,
      "tag-name": _vm.tagName,
      placeholder: _vm.placeholder,
      "static-options": _vm.staticOptions,
      "popper-class": _vm.popperClass,
      "latest-used-data-key": _vm.latestUsedDataKey
    },
    on: {
      enter: function($event) {
        return _vm.$emit("enter")
      },
      parentCallBack: _vm.onParentCallBack
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }